// Copyright (c) Jupyter Development Team.
// Copyright (c) Microsoft Corporation.
// Distributed under the terms of the Modified BSD License.
import { css } from '@microsoft/fast-element';
/**
 * Styles for AnchoredRegion
 * @public
 */
export const anchoredRegionStyles = (context, definition) => css `
  :host {
    contain: layout;
    display: block;
  }
`;
